import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { CompanyModel } from 'app/models/company.model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CompanyService extends BaseService<CompanyModel> {
    private _selectedCompanyId = new BehaviorSubject<number | null>(null);
    public selectedCompanyId$: Observable<number | null> = this._selectedCompanyId.asObservable();

    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'company');
        // Load selected company from localStorage on service initialization
        const savedCompanyId = localStorage.getItem('selectedCompanyId');
        if (savedCompanyId) {
            this._selectedCompanyId.next(parseInt(savedCompanyId, 10));
        }
    }

    setSelectedCompanyId(companyId: number): void {
        this._selectedCompanyId.next(companyId);
        localStorage.setItem('selectedCompanyId', companyId.toString());
    }

    getSelectedCompanyId(): number | null {
        return this._selectedCompanyId.value;
    }

    getSelectedCompanyIdObservable(): Observable<number | null> {
        return this.selectedCompanyId$;
    }
}
